import React from 'react';
import { FileSpreadsheet } from 'lucide-react';

/** Step 2's "Extracted BOM · N components" strip, with the way into the editable sheet. */
export const ExtractedBomStrip: React.FC<{ count: number; onOpen: () => void }> = ({ count, onOpen }) => (
  <div className="flex items-center gap-s6 rounded-card border border-line bg-surface px-s6 py-[12px]">
    <span className="flex items-center gap-s3">
      <FileSpreadsheet className="h-[15px] w-[15px] shrink-0 text-success-ink" />
      <span className="text-row-title text-ink">Extracted BOM</span>
    </span>
    <span className="font-mono text-mono-data text-ink-secondary">{count} components</span>
    {count > 0 ? (
      <button
        type="button"
        onClick={onOpen}
        className="ml-auto text-body-sm font-semibold text-action hover:text-action-deep
          focus:outline-none focus-visible:ring-2 focus-visible:ring-action rounded-pill"
      >
        Open BOM →
      </button>
    ) : (
      <span className="ml-auto text-meta text-ink-muted">Nothing extracted yet</span>
    )}
  </div>
);

export default ExtractedBomStrip;
